const TransportationIcon = props => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="#7C3AED"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M17.7083 5.20825H3.12499C1.97916 5.20825 1.04166 6.13534 1.04166 7.29159V16.6666H3.12499C3.12499 18.3853 4.52082 19.7916 6.24999 19.7916C7.97916 19.7916 9.37499 18.3853 9.37499 16.6666H15.1042C15.1042 18.3853 16.5 19.7916 18.2292 19.7916C19.9583 19.7916 21.3542 18.3853 21.3542 16.6666H23.9583V11.4583L17.7083 5.20825ZM3.12499 11.4583V7.29159H7.29166V11.4583H3.12499ZM6.24999 18.2291C5.38541 18.2291 4.68749 17.5312 4.68749 16.6666C4.68749 15.802 5.38541 15.1041 6.24999 15.1041C7.11457 15.1041 7.81249 15.802 7.81249 16.6666C7.81249 17.5312 7.11457 18.2291 6.24999 18.2291ZM13.5417 11.4583H9.37499V7.29159H13.5417V11.4583ZM18.2292 18.2291C17.3646 18.2291 16.6667 17.5312 16.6667 16.6666C16.6667 15.802 17.3646 15.1041 18.2292 15.1041C19.0937 15.1041 19.7917 15.802 19.7917 16.6666C19.7917 17.5312 19.0937 18.2291 18.2292 18.2291ZM15.625 11.4583V7.29159H16.6667L20.8333 11.4583H15.625Z" />
  </svg>
)

export default TransportationIcon
